import { useState, useEffect } from 'react';
import { Grid, Button } from '@mui/material';
import { LocalOfferRounded } from '@mui/icons-material';
import StateManager from '../StateManager';
import SearchMenu from './SearchMenu';
import { isEmpty, isFunction, isString, isArray } from 'lodash';
import axios from 'axios';

export default function TagsSelector({
  value,
  onChange,
  returnObjects,
  buttonText = 'Select tags',
  buttonProps,
  ...props
}) {
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [checked, setChecked] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tags, setTags] = useState([]);

  const loadTags = menuAnchor && isEmpty(tags);

  useEffect(() => {
    if (!loadTags) return;

    setLoading(true);
    axios
      .get('/tags/getCompanyTags')
      .then(({ data }) => setTags(data))
      .catch((err) => StateManager.setAxiosErrorAlert(err))
      .finally(() => setLoading(false));
  }, [loadTags]);

  useEffect(() => {
    if (!isArray(value)) return;

    // ids array passed
    if (value.every((x) => isString(x))) {
      setChecked(value);
    } else if (value.every((x) => isString(x._id))) {
      // if objects passed
      setChecked(value.map((x) => x._id));
    }
  }, [value]);

  function saveTags(ids) {
    if (!isArray(ids)) return;

    setChecked(ids);
    const result = returnObjects ? tags.filter((x) => ids.includes(x._id)) : ids;
    isFunction(onChange) && onChange(result);
  }

  return (
    <Grid item {...props}>
      <Button
        onClick={(e) => setMenuAnchor(e.currentTarget)}
        variant="outlined"
        startIcon={<LocalOfferRounded />}
        {...buttonProps}
      >
        {buttonText}
      </Button>

      <SearchMenu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={() => setMenuAnchor(null)}
        map={(x) => x}
        idField="_id"
        withColor
        items={tags}
        withCheckboxes
        checkedItems={checked}
        onCheck={(id) => saveTags([...checked, id])}
        onUncheck={(id) => saveTags(checked.filter((x) => x !== id))}
        loading={loading}
      />
    </Grid>
  );
}
